import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastService } from '@siu/shared';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IDatoValidar } from '../interface/transversal.interface';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class TransversalService extends BaseService {

  private urlApiGatewayTrasnversal: string = `${environment.apiGatewayAddress}/t/v1`;
  private urlApiGateway: string = `${environment.apiGatewayAddress}/api/v1/Transversal`;

  constructor(private http: HttpClient, toast: ToastService) {
    super(toast);
  }

  listarDepartamentos = (): Observable<any> => {

    return this.http.get(`${this.urlApiGatewayTrasnversal}/Ubigeo/Listar-Items-Departamento`)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(this.handleErrorResponse)
      );
  };

  listarProvinciasPorDepartamento = (
    UbiDep: string,
  ): Observable<any> => {
    return this.http.get(`${this.urlApiGatewayTrasnversal}/Ubigeo/Listar-Items-Provincia`, {
      params: {
        UbiDep: `${UbiDep}`
      }
    });
  };

  listarDistritosPorProvincia = (
    UbiDep: string,
    UbiProv: string,
  ): Observable<any> => {
    return this.http.get(`${this.urlApiGatewayTrasnversal}/Ubigeo/Listar-Items-Distrito`, {
      params: {
        UbiDep: `${UbiDep}`,
        UbiProv: `${UbiProv}`
      }
    });
  };

  getRepresentanteLegalPorRUC = (strRuc: string): Observable<any> => {
    return this.http.get(`${this.urlApiGatewayTrasnversal}/Sunat/Buscar-RepresentanteLegal-PorRUC`, {
      params: {
        ruc: `${strRuc}`
      }
    })
  }

  validarDatosPago = (request: IDatoValidar): Observable<any> => {
    return this.http.post(`${this.urlApiGateway}/Validar-Comprobante-Pago`, request).pipe(
      map(response => {
        return response;
      }),
      catchError(this.handleErrorResponse)
    );
  };

  obtenerComprobantePagoByExpediente = (idExpediente: number, idModulo: number): Observable<any> => {

    var params = { eExpediente: idExpediente, eModulo: idModulo };

    return this.http.post(`${this.urlApiGateway}/Obtener-Comprobante-Pago`, params).pipe(
      map(response => {
        return response;
      }),
      catchError(this.handleErrorResponse)
    );
  };

  
}
